import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import AIShowcase from './components/AIShowcase';
import Differentiators from './components/Differentiators';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import './App.css';

function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <AIShowcase />
      <Differentiators />
      <CTA />
    </>
  );
}

function App() {
  return (
    <div className="app">
      <div className="bg-gradient" />
      <div className="bg-grid" />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
